import React from "react";
import { SettingsModal } from "../features/translator/components/SettingsModal";
import { DocsModal } from "../features/translator/components/DocsModal";
import { SummaryModal } from "../features/translator/components/SummaryModal";
import { ProfileModal } from "../features/auth/components/ProfileModal";
import { StopConfirmModal } from "../features/translator/components/StopConfirmModal";
import { LogoutConfirmModal } from "../features/translator/components/LogoutConfirmModal";
import type { UseTranslatorReturn } from "../features/translator/hooks/useTranslator";

interface ModalsContainerProps {
  modals: ReturnType<typeof import("../hooks/useAppModals").useAppModals>;
  auth: UseTranslatorReturn;
  onStopConfirm: () => void;
  onLogoutConfirm: () => void;
}

export const ModalsContainer: React.FC<ModalsContainerProps> = ({ modals, auth, onStopConfirm, onLogoutConfirm }) => {
  return (
    <>
      <SettingsModal
        isOpen={modals.settingsOpen}
        onClose={() => modals.setSettingsOpen(false)}
        onSave={auth.saveSettings}
        initialSettings={auth.settings}
      />

      <DocsModal
        isOpen={modals.docsOpen}
        onClose={() => modals.setDocsOpen(false)}
      />

      <SummaryModal
        isOpen={modals.summaryOpen}
        onClose={() => {
          if (!modals.savedSummaryModalData) {
            auth.clearCurrentSession();
          }
          modals.closeSummary();
        }}
        meetingTranscript={auth.meetingTranscript}
        currentMeetingId={modals.savedSummaryModalData ? modals.savedSummaryModalData.meeting._id.toString() : auth.currentMeetingId}
        summaryServiceUrl={auth.settings.summaryServiceUrl}
        translatorServiceUrl={auth.settings.translatorServiceUrl}
        targetLang={modals.savedSummaryModalData ? modals.savedSummaryModalData.meeting.target_lang : auth.tgtLang}
        targetLangLabel={auth.getLanguageLabel(modals.savedSummaryModalData ? modals.savedSummaryModalData.meeting.target_lang : auth.tgtLang)}
        initialSummaryText={modals.savedSummaryModalData?.summaryText}
        initialTitle={modals.savedSummaryModalData?.meeting?.title}
        initialDuration={modals.savedSummaryModalData ? modals.savedSummaryModalData.meeting?.duration : auth.recordingDuration}
        initialTranscriptCount={modals.savedSummaryModalData?.meeting?.transcript_count}
        isSavedSummary={!!modals.savedSummaryModalData}
        appMode={auth.appMode}
        onUpdateSavedTitle={modals.updateSavedSummaryTitle}
        initialFolderId={modals.savedSummaryModalData?.meeting?.folder_id}
        initialTags={modals.savedSummaryModalData?.meeting?.tags}
      />

      <ProfileModal
        isOpen={modals.profileOpen}
        onClose={() => modals.setProfileOpen(false)}
        userServiceUrl={auth.settings.userServiceUrl}
      />

      <StopConfirmModal
        isOpen={modals.stopConfirmOpen}
        onClose={() => modals.setStopConfirmOpen(false)}
        onConfirm={onStopConfirm}
      />

      <LogoutConfirmModal
        isOpen={modals.logoutConfirmOpen}
        onClose={() => modals.setLogoutConfirmOpen(false)}
        onConfirm={onLogoutConfirm}
        recording={auth.recording}
      />
    </>
  );
};
